// Classic's own copy (#1119): one area folder per page or part, imported
// here as one key each. Shared words (league concepts, statuses, sport-pack
// terms, page strings every template uses) stay in site-core and shared.
import chrome from './chrome/en'
import home from './home/en'
import schedule from './schedule/en'
import game from './game/en'
import player from './player/en'
import team from './team/en'
import players from './players/en'
import stats from './stats/en'
import gallery from './gallery/en'
import live from './live/en'
import sale from './sale/en'
import form from './form/en'
import venues from './venues/en'

const en = {
  chrome,
  home,
  schedule,
  game,
  player,
  team,
  players,
  stats,
  gallery,
  live,
  sale,
  form,
  venues,
}

export default en
